const APIS = {
  STAFF: "/logisticservice/api/staff/",
  USER: "/usermanagementservice/api/user/",
  EMAIL: "/mailboxservice/api/mailbox/",
  UPLOAD_FILE: "/mailboxservice/api/upload-s3/",
  USER_PROFILE: "/logisticservice/api/user-profile/",
  FILE:"/driveservice/api/file/chunk-upload/",
  CONTACTS:"mailboxservice/api/contacts/",
  ACCOUNTS: "/mailboxservice/api/accounts/",

};

export default APIS;
